import "../../index65.css";
import { jsxs as A, jsx as m } from "react/jsx-runtime";
import { useState as et, useRef as st, useMemo as at, useCallback as T, Fragment as B } from "react";
import { i as p, a as D } from "../../type-BFTbooL7.js";
import { _ as u } from "../../cs-piwRuCFZ.js";
import { l as nt } from "../../transform-VOqkQszh.js";
import { b as I } from "../../statistics-IyDYgeE6.js";
import rt from "../../hooks/useSizeTracking.js";
import { getBounds as ot, getScaleFunction as O, getPathData as ct } from "../../utils/chart.js";
import { j as it } from "../../common-UUpiO33D.js";
import mt from "./ChartPoint/index.js";
const lt = "_timeline-chart_1mks7_1", xt = "_y-axis-tick-text_1mks7_6", ut = "_x-axis-tick-text_1mks7_11", ht = "_x-axis-grid-line_1mks7_21", dt = "_y-axis-grid-line_1mks7_22", yt = "_hovered_1mks7_28", ft = "_rect_1mks7_33", r = {
  timelineChart: lt,
  yAxisTickText: xt,
  xAxisTickText: ut,
  xAxisGridLine: ht,
  yAxisGridLine: dt,
  hovered: yt,
  rect: ft
}, V = 20, j = 10, o = 10, l = {
  left: 2 * j + o,
  top: o,
  right: o * 2,
  bottom: 2 * V + o
}, kt = (g) => {
  const v = new Date(g);
  return it(v, "yyyy-MM");
};
function wt(g) {
  const {
    className: v,
    xAxisTickClassName: X,
    dataKeys: h,
    timePoints: S,
    valueSelector: N,
    classNameSelector: C,
    activePointKey: W,
    onTimePointClick: _,
    xAxisFormatter: $
  } = g, [b, w] = et(), L = st(null), a = rt(L), [
    F,
    G
  ] = at(
    () => {
      if (p(a))
        return [
          [],
          []
        ];
      const t = S.map((e) => {
        const n = h.map((i) => ({
          key: i,
          value: N(i, e)
        })), y = n.map((i) => i.value).filter(D), f = y.length === 0 ? 0 : Math.max(...y);
        return {
          date: e,
          numMonths: e.getFullYear() * 12 + e.getMonth(),
          dataValues: n,
          maxValue: f
        };
      }), s = t.map((e) => e.maxValue), x = s.length === 0 ? 0 : Math.max(...s), c = t.map((e) => e.numMonths), K = ot(c), M = O(
        K,
        { min: 0, max: a.width },
        { start: l.left, end: l.right }
      ), d = 5, E = Math.ceil(x / d) * d, H = {
        min: 0,
        max: E
      }, R = O(
        { min: 0, max: H.max },
        { min: 0, max: a.height },
        { start: l.top, end: l.bottom },
        !0
      ), Q = E / d, U = Array.from(Array(d + 1).keys()).map((e) => {
        const n = H.min + Q * e;
        return {
          key: e,
          dataValue: n,
          value: R(n)
        };
      });
      return [
        t.map((e, n) => {
          const y = M(e.numMonths), f = n === 0, i = n === t.length - 1, Z = f ? e : t[n - 1], P = i ? e : t[n + 1], Y = M(
            (Z.numMonths + e.numMonths) / 2
          ) + (f ? -10 : 0), tt = M(
            (e.numMonths + P.numMonths) / 2
          ) + (i ? o : 0);
          return {
            key: kt(e.date),
            x: y,
            yValues: nt(
              e.dataValues,
              (k) => k.key,
              (k) => D(k.value) ? R(k.value) : void 0
            ),
            rect: {
              start: Y,
              width: I(tt - Y, 0, a.width)
            },
            date: e.date,
            numMonths: e.numMonths,
            values: e.dataValues
          };
        }),
        U
      ];
    },
    [a, h, S, N]
  ), z = T((t) => {
    const s = t.target.getAttribute("data-key");
    s && _ && _(s);
  }, [_]), q = T((t) => {
    w(t.target.getAttribute("data-key") ?? void 0);
  }, []), J = T(() => {
    w(void 0);
  }, []);
  return /* @__PURE__ */ A(
    "svg",
    {
      className: u(r.timelineChart, v),
      ref: L,
      children: [
        G && G.map((t, s) => /* @__PURE__ */ A(B, { children: [
          /* @__PURE__ */ m(
            "text",
            {
              className: r.yAxisTickText,
              x: j,
              y: t.value + s * 2,
              children: t.dataValue
            }
          ),
          /* @__PURE__ */ m(
            "line",
            {
              className: r.xAxisGridLine,
              x1: l.left - o,
              y1: t.value,
              x2: a.width - o,
              y2: t.value
            }
          )
        ] }, t.key)),
        h.map((t) => /* @__PURE__ */ m(
          "path",
          {
            className: u(r.path, C(t)),
            d: ct(
              F.map((s) => {
                const { x } = s, c = s.yValues[t];
                if (!(p(x) || p(c)))
                  return {
                    x,
                    y: c
                  };
              }).filter(D)
            )
          },
          t
        )),
        F.map((t) => {
          const s = t.key === W, x = t.key === b;
          return /* @__PURE__ */ A(B, { children: [
            /* @__PURE__ */ m(
              "text",
              {
                className: u(X, r.xAxisTickText),
                x: t.x,
                y: a.height - V,
                style: {
                  transformOrigin: `${t.x}px ${a.height - V}px`
                },
                children: $(t.date)
              }
            ),
            /* @__PURE__ */ m(
              "line",
              {
                className: u(
                  r.yAxisGridLine,
                  b === t.key && r.hovered
                ),
                x1: t.x,
                y1: 0,
                x2: t.x,
                y2: a.height - l.bottom + o
              }
            ),
            h.map((c) => /* @__PURE__ */ m(
              mt,
              {
                active: s,
                hovered: x,
                className: u(r.point, C(c)),
                x: t.x,
                y: t.yValues[c]
              },
              c
            )),
            /* @__PURE__ */ m(
              "rect",
              {
                className: r.rect,
                "data-key": t.key,
                x: t.rect.start,
                y: o,
                width: t.rect.width,
                height: I(
                  a.height - l.bottom,
                  0,
                  a.height
                ),
                onMouseEnter: q,
                onMouseOut: J,
                onMouseDown: z
              }
            )
          ] }, t.key);
        })
      ]
    }
  );
}
export {
  wt as default
};
